import service from '../axios/$axios';
import { queryParam } from '../utils';

export const get = (url, param, config) => service.get(`${url}?${queryParam(param)}`, config);
export const findById = (url, id) => service.get(`${url}/${id}`);
export const create = (url, body) => service.post(`${url}`, body);
export const update = (url, id, body) => service.put(`${url}/${id}`, body);
export const deleteRecord = (url, id, body) => {
	if (body) {
		return service.delete(`${url}`, body);
	} else {
		return service.delete(`${url}/${id}`);
	}
};

export const post = (url, body, cfg) => service.post(`${url}`, body, cfg);
